export default __webpack_public_path__ + "static/media/7-1.531756a2.mp3";